import React, { useState } from 'react'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap';
import { getItem, setItem } from '../../config/localStorage';
import SpinLoader from '../../component/loader/SpinLoader';

function WebsitePortfolioModal(props) {
    const getWebsitePortfolioData = JSON.parse(getItem('webPortProfileData'));
    const [websitePortfolio, setWebsitePortfolio] = useState({
        'wpLinkOne': getWebsitePortfolioData !== null ? getWebsitePortfolioData.wpLinkOne : '',
        'wpLinkTwo': getWebsitePortfolioData !== null ? getWebsitePortfolioData.wpLinkTwo : '',
        'wpLinkThree': getWebsitePortfolioData !== null ? getWebsitePortfolioData.wpLinkThree : '',
    });
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState('');
    const {setPersonalCheckbox,...rest} = props

    const WebsitePortfolioInfo = (e) => {
        e.preventDefault();
        setError('');
        setLoader(true);
        setSuccess('')

        const wpFormData = new FormData(e.target);
        const wpLinkOne = wpFormData.get('wp-link-one')?.trim();
        const wpLinkTwo = wpFormData.get('wp-link-two')?.trim();
        const wpLinkThree = wpFormData.get('wp-link-three')?.trim();

        if (!wpLinkOne) {
            setLoader(false);
            setError('Star field is required!');
            return;
        }

        if ((wpLinkTwo !== '' && wpLinkOne === wpLinkTwo) || (wpLinkThree !== '' && wpLinkOne === wpLinkThree) || (wpLinkTwo !== '' && wpLinkTwo === wpLinkThree && wpLinkThree !== '')) {
            setLoader(false);
            setError('Oops! It looks like some of the input values are the same!');
            return;
        }

        const formattedData = {
            'wpLinkOne': wpLinkOne,
            'wpLinkTwo': wpLinkTwo,
            'wpLinkThree': wpLinkThree,
        };

        setWebsitePortfolio(formattedData);

        setSuccess('Thank you for providing your website/portfolio/Profiles details.');

        if (getItem('webPortProfile') !== null) {
            setWebsitePortfolio(formattedData);
            setItem('webPortProfileData', JSON.stringify(formattedData));
        }
        setPersonalCheckbox((prev)=> !prev)
        setLoader(false);

    }

    const closePopUp = () => {
        setPersonalCheckbox((prev)=> !prev)
        setSuccess('')
        setError('')
    };

    return (
        <>
            <Modal
                {...rest}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton variant="secondary" onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Websites, Portfolios, Profiles
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={WebsitePortfolioInfo}>
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Link/URL <span className="fa fa-star requierd-star"></span></Form.Label>
                                    <Form.Control type="url" name="wp-link-one" placeholder='ex.linkedin.com/in/yourname' defaultValue={websitePortfolio.wpLinkOne} />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Link/URL</Form.Label>
                                    <Form.Control type="url" name="wp-link-two" defaultValue={websitePortfolio.wpLinkTwo} />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Link/URL</Form.Label>
                                    <Form.Control type="url" name="wp-link-three" defaultValue={websitePortfolio.wpLinkThree} />
                                </Form.Group>
                            </Col>

                            {
                                error != '' ?
                                    <Col md={12}>
                                        <div className="alert alert-danger" role="alert">
                                            {error}
                                        </div>
                                    </Col>
                                    : ''
                            }

                            {
                                success != '' ?
                                    <Col md={12}>
                                        <div className="alert alert-success" role="alert">
                                            {success}
                                        </div>
                                    </Col>
                                    : ''
                            }


                            <Modal.Footer>
                                {
                                    loader ? <SpinLoader /> : ''
                                }
                                <Button className='button-green' type="submit">Save changes</Button>
                            </Modal.Footer>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default WebsitePortfolioModal
